// extracted by css-extract-rspack-plugin
module.exports =  {"access_requested_modal":"AccessRequestedInfo_access_requested_modal__zDnud"};